import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { configuration } from 'src/app/app.config';
import { Logger, transformError } from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';

@Injectable()
export class AppInsightsLogger implements Logger {
  private _enabled: boolean = configuration.logging.applicationInsights.enabled;

  public error(error: Error | string): void {
    if (this._enabled) {
      const errInfo = transformError(error);
      const err = errInfo.error instanceof Error ? errInfo.error : new Error(errInfo.error);
      AppInsights.trackException(
        err,
        undefined,
        errInfo.properties,
        undefined,
        AI.SeverityLevel.Error,
      );
    }
  }

  public warning(message: string): void {
    if (this._enabled) {
      AppInsights.trackTrace(message, undefined, AI.SeverityLevel.Warning);
    }
  }

  public info(message: string): void {
    if (this._enabled) {
      AppInsights.trackTrace(message, undefined, AI.SeverityLevel.Information);
    }
  }
}
